import './App.css';
import '@fontsource/noto-sans/300.css';
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/500.css';
import '@fontsource/noto-sans/600.css';
import '@fontsource/noto-sans/700.css';
import '@fontsource/noto-sans/800.css';
import '@fontsource/noto-sans/900.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import {createContext, useEffect, useState} from "react";
import {contarWheres} from "./Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";

export const contexApp = createContext()

function App() {
    const [numTours, setNumTours] = useState({})

    const valoresProvider = {
        numTours
    }

    const {Provider} = contexApp;

    const obtenerNumeros = async () => {

        let nums = {}

        let wAventura = [where('categoria', '==', 'Aventura')]
        let wMar = [where('categoria', '==', 'Mar')]
        let wTierra = [where('categoria', '==', 'Tierra')]

        let doxAve = await contarWheres({coleccion: 'tours', wheres: wAventura})
        nums.Aventura = doxAve.data

        let doxMar = await contarWheres({coleccion: 'tours', wheres: wMar})
        nums.Mar = doxMar.data

        let doxTierra = await contarWheres({coleccion: 'tours', wheres: wTierra})
        nums.Tierra = doxTierra.data

        setNumTours(nums)

    }

    useEffect(() => {
        obtenerNumeros()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

        </Grid>
    );
}

export default App;
